module.exports = __webpack_public_path__ + "img/tips4.f00d0bb5.png";